export const SUPPORTED_USER_LANGUAGES = [
  { code: 'en', name: 'English' },
  { code: 'fr', name: 'Français' },
  { code: 'es', name: 'Español' },
  { code: 'de', name: 'Deutsch' },
  { code: 'pt', name: 'Português' },
] as const;

export const LANGUAGE_UNSET_VALUE = '__UNSET__';

export const DISABILITY_UNSET_VALUE = '__UNSET__';
export const DISABILITY_TRUE_VALUE = 'true';
export const DISABILITY_FALSE_VALUE = 'false';

export const formatCsvMappingLabel = (value: string): string =>
  value.trim() === '' ? '(vide)' : value;
